import MainContent from '@/components/layout/MainContent.vue'
import { _, isAuthorized, isGlobalPiloteOrAuditor, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

import { dashboardsRoutes } from '@/contexts/dashboards/Dashboards.routes'
import { perimetersRoutes } from '@/contexts/perimeters/Perimeters.routes'
import { BENCHMARK_ROUTE_NAME } from '@/contexts/benchmark/Benchmark.constants'

export const performanceRoutes: RouteConfig = {
  path: '/org2',
  name: 'organization2',
  component: MainContent,
  meta: {
    title: _('Performance'),
    dummy: true,
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    is_authorized: (route: Route) => isAuthorized(route),
  },
  children: [
    perimetersRoutes,
    {
      path: '/benchmark',
      name: BENCHMARK_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/benchmark/BenchmarkView.vue')),
      meta: {
        title: _('Benchmark'),
        icon: 'chart-line',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: isGlobalPiloteOrAuditor,
        doc_id: 'benchmark',
        feature_id: 'POLICIES',
      },
      children: [],
    },
    dashboardsRoutes,
  ],
}
